import { getRecruiterCompanyAgreement } from '@/api/recruiter';
import { useApiQuery } from '@/hooks/api';
import { LISTING_STALE_TIME } from '@/hooks/api/defaults';
import { queryKeys } from '@/shared/lib/queryKeys';

import type { CompanyAgreement } from '@/types/company';

export function useRecruiterCompanyAgreement(
  agreementId: string | null | undefined,
  options?: { enabled?: boolean },
) {
  return useApiQuery<CompanyAgreement | null>({
    queryKey: queryKeys.recruiter.companyAgreement(agreementId ?? ''),
    queryFn: async () => {
      if (!agreementId) return null;
      const res = await getRecruiterCompanyAgreement(agreementId);
      return res ?? null;
    },
    enabled: Boolean(agreementId) && (options?.enabled ?? true),
    staleTime: LISTING_STALE_TIME,
  });
}
